import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

import type { InvoiceTransaction, TransactionRecord } from 'app-components/flux/transactions/transactionsTypes';

export const MATCH_SALES_RECEIPT_ROOTUI_TYPE = 'MATCH_SALES_RECEIPT_DIALOG';

type MatchSalesReceiptDialogProps = {
  receipt?: InvoiceTransaction;
  dialogId?: string;
  onClose?: () => void;
  onSelect?: (txn: TransactionRecord) => void;
};

export const showMatchSalesReceiptDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({ dialogId, receipt, onClose, onSelect }: MatchSalesReceiptDialogProps) => {
    const resolvedDialogId = dialogId || `match-sales-receipt-${receipt?.id ?? 0}`;

    return rootUiTypes.mkRootUiData({
      id: resolvedDialogId,
      type: MATCH_SALES_RECEIPT_ROOTUI_TYPE,
      props: ImmutableMap({
        receipt,
        onClose,
        onSelect,
      }),
    });
  },
);
